
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Job } from '../../global/models'

@Component
export default class AbandonJobModal extends Vue {
  private job: Job | null = null

  private show = false

  private valid = false

  private reason: string | null = null
  
  open(job: Job) {
    this.job = { ...job }
    this.show = true
  }

  close() {
    this.show = false
    this.job = null
  }

  confirm() {
    const data = {
      job: { ...this.job },
      reason: this.reason
    }
    this.$emit('confirm', data)
    this.close()
  }
}
